import React from 'react';
import Navbar from '../components/layout/Navbar';

function NotFound() {
  return (
    <div className="not-found-page">
      <Navbar />
      <div className="content" style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
    </div>
  );
}

export default NotFound;
